import PropTypes from 'prop-types'
import React from 'react'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import { useColor } from 'utils/colors'

const Tag = React.forwardRef(({
  name,
  color,
  isSelected,
  ...props
}, ref) => {
  const tagColor = useColor(color)

  return (
    <ListItem
      ref={ref}
      active={isSelected}
      icon={
        <KanBoIcon
          name='kanbo-16-label'
          style={{
            color: tagColor,
          }}
        />
      }
      {...props}
    >
      {name}
    </ListItem>
  )
})

export class Tags extends React.Component {
  static propTypes = {
    selectedTags: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,
    onTagClick: PropTypes.func
  }

  render () {
    const {
      selectedTags,
      tags,
      onTagClick
    } = this.props

    return (
      <ul className='list-group'>
        {tags.map(tag => {
          const isSelected = selectedTags.indexOf(tag.id) !== -1

          const onClick = (event) => {
            if (onTagClick) onTagClick(tag, event)
          }

          return (
            <Tag
              key={tag.id}
              name={tag.name}
              color={tag.color}
              active={isSelected}
              onClick={onClick}
            />
          )
        })}
      </ul>
    )
  }
}

export default Tags
